module.exports = __webpack_public_path__ + "img/mocha.9776f178.png";